import { SerializedStyles } from "@emotion/react";
import styled from "@emotion/styled";
import classNames from "classnames";
import Popper, { Behavior, Placement, PopperOptions, Position } from "popper.js";
import * as React from "react";

interface IStyledPopupProps {
  contentPosition?: string;
  contentZIndex?: number;
  childrenZIndex?: number | string;
  arrowCss?: SerializedStyles;
  boundariesElement?: HTMLDivElement | "viewport";
}

const StyledPopup = styled.div<IStyledPopupProps>`
  z-index: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.childrenZIndex
  };

  .popper-popup {
    z-index: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.contentZIndex
    };
    display: none;
    position: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.contentPosition
    };

    &.show {
      display: block;
    }
  }

  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.arrowCss
  };
`;

interface IPopperContainerProps extends IStyledPopupProps {
  children?: React.ReactNode;
  content: React.ReactChild;
  placement: Placement;
  offset: number | string;
  isVisible: boolean;
  arrowCss?: SerializedStyles;
  flipBehavior?: Behavior | Position[];
  preventOverflow?: boolean;
  contentClassName?: string;
  contentCss?: SerializedStyles;
  onClose?(): void;
  onOpen?(): void;
}

export default class StatelessPopperContainer extends React.PureComponent<IPopperContainerProps> {
  static defaultProps = {
    childrenZIndex: 2100,
    contentZIndex: 2000,
    flipBehavior: "flip",
    preventOverflow: true,
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentDidMount() {
    if (this.props.isVisible) {
      this.initializePopper();
    }
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentDidUpdate(prevProps: IPopperContainerProps) {
    const isShown = !prevProps.isVisible && this.props.isVisible;
    const isHidden = prevProps.isVisible && !this.props.isVisible;

    if (isShown) {
      this.initializePopper();
    }

    if (isHidden) {
      this.removeEventHandlers();
    }
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  componentWillUnmount() {
    if (this.popperInstance) {
      this.popperInstance.destroy();
      // @ts-expect-error TS(2322)
      this.popperInstance = null;
    }

    this.removeEventHandlers();
  }

  private get popperOptions(): PopperOptions {
    const { boundariesElement, placement, offset, flipBehavior, preventOverflow, arrowCss } = this.props;

    return {
      placement,
      positionFixed: true,
      modifiers: {
        offset: {
          offset,
        },
        flip: {
          enabled: true,
          behavior: flipBehavior,
          boundariesElement: boundariesElement || "viewport",
        },
        arrow: {
          // @ts-expect-error TS(2322)
          element: this.arrowRef.current,
          enabled: Boolean(arrowCss),
        },
        hide: {
          enabled: false,
        },
        preventOverflow: {
          enabled: preventOverflow,
        },
      },
    };
  }

  private referenceElementRef: React.RefObject<HTMLDivElement> = React.createRef();
  private contentRef: React.RefObject<HTMLDivElement> = React.createRef();
  private arrowRef: React.RefObject<HTMLDivElement> = React.createRef();
  // @ts-expect-error TS(2322)
  private popperInstance: Popper;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private initializePopper = () => {
    if (!this.popperInstance) {
      // @ts-expect-error TS(2345)
      this.popperInstance = new Popper(this.referenceElementRef.current, this.contentRef.current, this.popperOptions);
    }

    this.addEventHandlers();
    this.popperInstance.scheduleUpdate();
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private addEventHandlers = () => {
    setTimeout(() => {
      document.addEventListener("click", this.handleDocumentClick);
    }, 0);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private removeEventHandlers = () => {
    document.removeEventListener("click", this.handleDocumentClick);
  };

  private handleDocumentClick = (event: Event): void => {
    if (this.props.onClose && this.contentRef.current && !this.contentRef.current.contains(event.target as Node)) {
      this.props.onClose();
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private toggle = () => {
    if (this.props.isVisible) {
      if (this.props.onClose) {
        this.props.onClose();
      }
    } else if (this.props.onOpen) {
      this.props.onOpen();
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const {
      children,
      content,
      contentZIndex,
      contentPosition,
      childrenZIndex,
      isVisible,
      contentClassName,
      arrowCss,
      contentCss,
    } = this.props;
    const classNameProp = {
      ...(contentClassName ? { className: contentClassName } : {}),
      ...(contentCss ? { css: contentCss } : {}),
    };

    return (
      <StyledPopup
        contentZIndex={contentZIndex}
        contentPosition={contentPosition}
        childrenZIndex={childrenZIndex}
        arrowCss={arrowCss}
      >
        <div ref={this.referenceElementRef} onClick={this.toggle} {...classNameProp}>
          {children}
        </div>

        <div className={classNames("popper-popup", { show: isVisible })} css={contentCss} ref={this.contentRef}>
          {arrowCss && <div className="popper-arrow" ref={this.arrowRef} />}
          {content}
        </div>
      </StyledPopup>
    );
  }
}
